import { PublicClientApplication } from "@azure/msal-browser";
import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { MEMBERS_PORTAL } from "../../accounts/Consts";

interface IPrivateRouteProps {
    component: React.ReactType;
    path: string;
    exact?: boolean;
    instance: PublicClientApplication;
    portalType: string,
    scope?: any,
    client?: string
}

const getIsAuthenticated = () => {
    return sessionStorage.isAuthenticated && sessionStorage.isAuthenticated == 'true' ? true : false
}

const isNoIpUser = () => {
    const currentUserNameNumber = sessionStorage.getItem('currentUserNameNumber');
    if (!currentUserNameNumber) {
        return true;
    }
    return /^\s*0+\s*$/.test(currentUserNameNumber);
}

const isNoIpAllowedPath = (pathname: string) => {
    if (pathname === "/" || pathname.startsWith("/myAccount")) {
        return true;
    }

    const menuItemsSession = sessionStorage.getItem('menuItems');
    if (!menuItemsSession) {
        return true;
    }

    const menuItems = JSON.parse(menuItemsSession);
    const root = "/" + (pathname.split("/")[1] || "");
    const item = menuItems && menuItems.find(m => m && m.link === root);

    return !item || !item.children || item.children.length === 0;
}

const PrivateRoute: React.SFC<IPrivateRouteProps> = ({
    component: Component,
    ...rest
}) => (

    <Route
        {...rest}
        render={props => {
            if (getIsAuthenticated()) {
                if (rest.portalType === MEMBERS_PORTAL && isNoIpUser() && !isNoIpAllowedPath(props.location.pathname)) {
                    return <Redirect to={{ pathname: "/myAccount/viewAs", state: { from: props.location } }} />;
                }
                return <Component {...props} />
            }
            else if (rest.portalType === MEMBERS_PORTAL) {
                rest.instance
                    .handleRedirectPromise()
                    .then((tokenResponse) => {
                        if (!tokenResponse) {
                            const accounts = rest.instance.getAllAccounts();
                            if (accounts.length === 0) {
                                rest.instance.acquireTokenRedirect(rest.scope);
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                return null;
            }
            else { return <Redirect to={{ pathname: "/login", state: { from: props.location } }} /> }
        }}
    />
);

export { PrivateRoute };